import React, { useState, useEffect, useContext } from 'react';
import { api } from '../../../api';
import { ModelContext } from '../../metadata/ModelSource';
import { ProductInfoContext } from '../../data/ApplicationDataSource';
import {FormContext} from "../../metadata/MDForm";
import Row from 'antd/lib/grid/row';
import Col from 'antd/lib/grid/col';
import _ from 'lodash';
import memoize from 'fast-memoize';
import { CoverageField } from './CoverageField';
import { Collapse } from "antd";
import {DownOutlined, RightOutlined} from "@ant-design/icons";
const { Panel } = Collapse;

function getAdditionalCoveragesRisk(systemId, lineCd, riskNumber) {
  return api
    .get(
      `/applications/${systemId}/lines/${lineCd}/risks/${riskNumber}/availableCoverages`
    )
    .then((v) => {
      return v;
    })
    .catch((err) => console.log('Err', err));
}

function getAdditionalCoveragesLine(systemId, lineCd) {
  return api
    .get(`/applications/${systemId}/lines/${lineCd}/availableCoverages`)
    .then((v) => {
      return v;
    })
    .catch((err) => console.log('Err', err));
}

function toCoverageField({coverageCd, lineCd, displayDesc, ...restOpt}){
  const form = toForm(coverageCd, restOpt);
  return {
    isOptional: true,
    coverageCd,
    lineCd,
    label: displayDesc,
    attr: restOpt,
    ...(form ? {form} : {})
  }
}

function toForm(coverageCd, option){
  const isTableSummary = _.get(option, "productScheduledLocations") || _.get(option, "productScheduledItems")
  const items = isTableSummary 
    ? (_.get(option, "productScheduledLocations") || _.get(option, "productScheduledItems") || [])
    : (_.get(option, "attributes.attributes") || [])
  if(items.length === 0) return null;
  const content = isTableSummary
    ? [{
        CoverageItems: {
        coverageCd, items, option
      }
    }]
    : items
      .filter(attr => attr && attr.id !== "Limit1.Value")
      .map(attr => attr 
        ? { Field: {attr: attr.id, metadata: attr, showCheckbox: false, nestedCoverage: true, showTopLabel: true }}
        : null
      )
    return {Group: {content}}
}


export function AdditionalRiskCoverages({ lineCd, riskTypeCd, form, nestedComponent, showFields, showFieldsHintText, formTitle, ...props }) {
  const { productSetup } = useContext(ProductInfoContext);
  const [riskCoverages, setRiskCoverages] = useState(undefined);
  const [lineCoverages, setLineCoverages] = useState(undefined);
  const [activeKey, setActiveKey] = useState('0');
  const applicationModel = useContext(ModelContext);
  const formContext = useContext(FormContext);
  const systemId = applicationModel.data.systemId;
  const risk = applicationModel.getValue(`lines{lineCd:${lineCd}}.risks{typeCd:${riskTypeCd}}`);
  const riskNumber = risk.building.bldgNumber;
  const productSetupRiskLine =
    productSetup.productSubTypes.productSubType[0].productLine[0]
      .productRiskTypes.productRiskType[0].productCoverages;
  
  const getAttributeMetadataFromProductSetup = memoize(
    (productSetupContext) => {
      if (!productSetupContext.attributes) {
        return {};
      }

      const out = {};
      productSetupContext.attributes.attributes.forEach((attr) => {
        const { attributeMappings, label, ...directProps } = attr;
        const apiMapping = attributeMappings.find((am) => am.typeCd === 'API');
        if (!apiMapping) {
          return;
        }

        out[attr.id] = {
          label: label || attr.id,
          mapping: apiMapping.mapping,
          ...directProps,
        };
      });
      return out;
    }
  );
  const options = parseNestedAttributes(productSetupRiskLine.productCoverage, formContext.prefix);
  function parseNestedAttributes(dataArr, prefix) {
    return dataArr.reduce((resultValue, currentValue, index) => {
      resultValue.push({
        ...currentValue,
        lineCd,
        attributeMetadata: getAttributeMetadataFromProductSetup(currentValue),
        prefix,
      });
      return resultValue;
    }, []);
  }

  useEffect(() => {
    const getRiskInterests = async () => {
      return await getAdditionalCoveragesRisk(
        systemId,
        lineCd,
        riskNumber
      ).then((res) => {
        setRiskCoverages(res.data);
      });
    };

    const getLineInterests = async () => {
      return await getAdditionalCoveragesLine(systemId, lineCd).then((res) => {
        setLineCoverages(res.data);
      });
    };

    getRiskInterests();
    getLineInterests();
  }, []);

  const mapOptions = () => {
    return options
      .map(toCoverageField)
      .filter(v => showFields && showFields.indexOf(v.coverageCd) >= 0)
      .map((item, itmIx) => {
        const hintText = showFieldsHintText[item.coverageCd]
        item = hintText ? {...item, hintText}: {...item};
        return (
            <CoverageField {...item} dynamicCoverage lineCd="Homeowners" />
        )
      });
  };
  return (
    <Collapse
        expandIcon={(props) => {
          const { panelKey, isActive } = props;
          const iconClickAction = () => {
            if (activeKey === panelKey) {
              return setActiveKey('');
            }
            setActiveKey(panelKey);
          };
          return isActive ? <DownOutlined onClick={iconClickAction} /> : <RightOutlined onClick={iconClickAction} />;
        }}
        bordered={false}
        activeKey={activeKey}
        defaultActiveKey={'0'}
        accordion
        style={{ borderBottom: '0px' }}
    >
      <Panel header={formTitle} className='optional-coverages'>
        <Row style={{ display: 'flex', width: '100%', margin: '20px 0' }}>
          {options && <Col span={24}>{mapOptions()}</Col>}
        </Row>
      </Panel>
    </Collapse>
  );
}
